import React from 'react';
import { CtaBlock } from './ui/CtaBlock';
import { BONUS_TOTAL, OFFER_ANCHOR, PACK_IMAGE, PACK_IMAGE_ALT, PRICE, PRODUCT_NAME } from '../data/content';
export function FinalCTA() {
  return <section aria-labelledby="cierre" className="border-b border-crema bg-crema/60" data-id="element-53" data-mp="c7adc3u6m4g0">
      <div className="mx-auto max-w-xl px-4 py-6 text-center sm:py-9" data-id="element-54" data-mp="8573fjn5v7wu">
        <h2 id="cierre" className="font-serif text-3xl font-bold text-petroleo sm:text-4xl" data-id="element-55" data-mp="87a0uoqn83bl">
          Una última oportunidad
        </h2>
        <p className="mt-1.5 text-sm leading-snug text-azul/80" data-id="element-56" data-mp="h6dkpuxmwmr5">
          Podés seguir acumulando videos, consejos, planners y métodos de
          productividad mientras sentís que necesitás cambiar algo pero no sabés
          qué hacer primero. O podés comenzar hoy a reorganizar tus prioridades
          siguiendo una ruta clara y práctica.
        </p>
        <p className="mt-1.5 text-sm font-bold text-azul sm:text-base" data-id="element-57" data-mp="14tdb6ffdqgfc">
          No necesitás tener toda tu vida resuelta para empezar.{' '}
          <span className="font-hand text-3xl font-normal text-terracota sm:text-4xl" data-id="element-58" data-mp="2c56dc9woafm1">Necesitás dar el primer paso.</span>
        </p>

        <div className="mt-3 rounded-2xl border-2 border-dorado bg-blanco p-4" data-id="element-59" data-mp="2h49l4241ezxp">
          <a href={OFFER_ANCHOR} aria-label="Ir a la sección de compra" className="mx-auto block max-w-[16rem] overflow-hidden rounded-xl transition-transform duration-150 ease-soft active:scale-[0.99]" data-id="element-60" data-mp="2m1sxewh6d2n0">
            <img src={PACK_IMAGE} alt={PACK_IMAGE_ALT} className="block w-full" data-id="element-61" data-mp="2v1ocvdhrjjsu" />
          </a>
          <p className="mt-2.5 text-sm font-extrabold text-terracota" data-id="element-62" data-mp="300944nf1et55">✨ {PRODUCT_NAME}</p>
          <p className="text-sm font-bold text-azul" data-id="element-63" data-mp="34vezecubxk5w">6 Tomos + 5 Bonos</p>
          <p className="mt-1 text-sm text-azul/75" data-id="element-64" data-mp="39r3ti0nky8ut">
            Valor de los bonos: <span className="line-through" data-id="element-65" data-mp="3esayjryc8txs">{BONUS_TOTAL}</span>
          </p>
          <p className="font-serif text-4xl font-bold leading-tight text-azul sm:text-5xl" data-id="element-66" data-mp="3it3c2xe8tkzv">
            Hoy: <span className="text-petroleo" data-id="element-67" data-mp="1joczyjhcj9z6">{PRICE}</span>
          </p>
          <CtaBlock note="Acceso Inmediato • Entrega Digital • Garantía de 7 Días" data-id="element-68" data-mp="1jolf6i0xyrdj" />
        </div>
      </div>
    </section>;
}